import cx from "apps/website/utils/misc/cx";
import { themeRootClassMap } from "apps/website/maps/Theme.map";
import {
  paddingBottomMap,
  paddingLeftMap,
  paddingRightMap,
  paddingTopMap,
} from "apps/website/maps/Spacing.map";

import { componentPaddingMap, TMessagingCard } from "./MessagingCard.map";
import { EducationalCard } from "./Educational/EducationalCard";
import { FunctionalCard } from "./Functional/FunctionalCard";

const renderComponent = (props: TMessagingCard) => {
  switch (props.component) {
    case "educational":
      return <EducationalCard {...props} />;
    case "functional":
      return <FunctionalCard {...props} />;
    default:
      return null;
  }
};

export const MessagingCard = (props: TMessagingCard) => {
  const defaultPadding = componentPaddingMap[props.component];

  const {
    paddingTop = defaultPadding?.paddingTop,
    paddingBottom = defaultPadding?.paddingBottom,
    paddingLeft = defaultPadding?.paddingLeft,
    paddingRight = defaultPadding?.paddingRight,
    backgroundColor = "default",
  } = props.styleOptions ?? {};

  const computedClass = cx(
    "w-full rounded-[.25rem]",
    paddingTopMap[paddingTop],
    paddingBottomMap[paddingBottom],
    paddingLeftMap[paddingLeft],
    paddingRightMap[paddingRight],
    themeRootClassMap[backgroundColor ?? "default"],
  );

  return (
    <div className={computedClass} data-component={MessagingCard.name} id={props.id ?? "messagingCard"}>
      { renderComponent({ ...props }) }
    </div>
  );
};
